module.exports = __webpack_public_path__ + "media/src/images/icon__happy--3--dark-0e88ca73ffca46793a017efe48ac5d0a.png";